<style scoped>
@media (max-width: 992px) {
  .demo__fit-block {
    height: unset !important;
    min-height: unset !important;
    padding: 0 !important;
    padding-bottom: 50px !important;
  }
}
</style>
<template>
  <div class="demo__flex demo__flex-column demo__fit-block">
    <div class="demo__Content demo__padding-top--0">
      <HomeBanner
        class="demo__margin-top--46 demo__margin-bottom--38 demo__margin-bottom-mobile--15 demo__margin-top-mobile--0"
      />
      <a-row class="demo__margin-top--15">
        <HorizontalObjectBlock
          v-for="modul in _modules"
          :key="modul.id"
          :object="modul"
          :demo="false"
          :title="$t('Module_' + modul.id + '.title')"
          bg="bgPlateDark"
          :bgImage="require('@/assets/images/' + modul.id + '__bg.png')"
          color="white"
          :desc="{
            mobiledoc: false,
            field: 'descriptionMobiledoc',
            value: $t('Module_' + modul.id + '.desc'),
          }"
          :click-path="modul.url"
        />
      </a-row>
    </div>
    <div class="demo__flex-bottom" v-if="$root.showLogic">
      <Footer class="demo__margin-top--15" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import HorizontalObjectBlock from "Components/HorizontalObjectBlock";

import metaMixin from "Helpers/metaMixin";

import Footer from "Components/Footer";

import HomeBanner from "./components/HomeBanner";

export default {
  mixins: [metaMixin],
  components: {
    HorizontalObjectBlock,
    Footer,
    HomeBanner,
  },
  computed: {
    ...mapGetters([
      "modules",
      "user",
      "agent",
      "userLinks",
      "userIsBaseSub",
      "isMobile",
    ]),
    _modules() {
      return this.modules.filter((module) => {
        return !module.hideOnHomepage && !module.hide;
      });
    },
  },
  created() {
    document.title = this.$t("Home title");
  },
};
</script>
